import { useOrganization } from '@clerk/clerk-react';
import { ROLES } from '../constants/groups';

/**
 * Checks if the current organization member has a specific role.
 * @param {string} roleToCheck - e.g., 'org:admin'
 * @returns {boolean}
 */
export function useHasClerkRole(roleToCheck: string) {
  const { membership, isLoaded } = useOrganization();

  if (!isLoaded) return false;
  if (isLoaded && membership === null && roleToCheck === ROLES.ADMIN) return true; //for admins to be able to create a company
  if (isLoaded && !membership && roleToCheck !== ROLES.ADMIN) return false;
  return membership.role === roleToCheck;
}
